<template>
    <div class="hero-section container-global">
        <div class="">
            <section class="search-section">
                <div class="justify-center">
                    <div class="col-11 col-md-12 col-lg-12">
                        <div class="">
                            <h1 class="fs-1 text-weight-bold q-mb-sm"
                                :class="$q.screen.width <= 600 ? 'text-center' : ''">
                                أداة تقييم تجربة المستخدم للمواقع والمنتجات الرقمية واختبار
                                <span class="cycling-word">
                                    <span class="typing-text">{{ displayedWord }}</span>
                                    <span class="typing-cursor">|</span>
                                </span>
                            </h1>
                            <h2 class="fs-6 text-weight-medium q-my-lg q-my-md-xl">
                                أداة متخصصة في تقييم تجربة المستخدم الرقمية، تساعدك على اتخاذ قرارات مهمة من
                                خلال
                                آراء
                                موثوقة ومن
                                منظور مستخدمين فعليين.
                            </h2>
                            <div class="text-center button-container">
                                <button  tabindex="0"  role="button" class="primary_btn" @click="router.push({ name: 'SubscriptionPage' })">
                                    اطلب  تقرير خبير                                </button>
                                <button  tabindex="0"  role="button" class="primary_btn_outline" @click="router.push({ name: 'ExpertPage' })">
                                    زد دخلك بالتقييم                                 </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="" :class="$q.screen.width <= 600 ? 'full-width' : ''">
            <div class="">
                <template v-if="$q.screen.width > 910">
                    <MianShapHeroSection />
                </template>
                <template v-else>
                    <MianShapHeroSectionSmallWidth />
                </template>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import MianShapHeroSection from '@/components/ui/hero/MianShapHeroSection.vue';
import MianShapHeroSectionSmallWidth from '@/components/ui/hero/MianShapHeroSectionSmallWidth.vue';

const router = useRouter();
const $q = useQuasar();

// Words to cycle through
const cyclingWords = [
    'الشمولية الرقمية',
    'الكفاءة التقنية',
    'التصميم التفاعلي',
    'التصميم البصري',
    'هيكلة المعلومات',
    'المحتوى'
];

const currentWordIndex = ref(0);
const displayedWord = ref('');
let typingInterval: NodeJS.Timeout | null = null;

const typeWord = (word: string, cb: () => void) => {
    displayedWord.value = '';
    let i = 0;
    if (typingInterval) clearInterval(typingInterval);
    typingInterval = setInterval(() => {
        displayedWord.value += word[i];
        i++;
        if (i >= word.length) {
            clearInterval(typingInterval!);
            setTimeout(cb, 1200); // Wait before start deleting
        }
    }, 80); // typing speed
};

const deleteWord = (cb: () => void) => {
    let i = displayedWord.value.length;
    if (typingInterval) clearInterval(typingInterval);
    typingInterval = setInterval(() => {
        displayedWord.value = displayedWord.value.slice(0, -1);
        i--;
        if (i <= 0) {
            clearInterval(typingInterval!);
            setTimeout(cb, 300); // Wait before typing next word
        }
    }, 40); // delete speed
};

const startTypewriter = () => {
    typeWord(cyclingWords[currentWordIndex.value], () => {
        deleteWord(() => {
            currentWordIndex.value = (currentWordIndex.value + 1) % cyclingWords.length;
            startTypewriter();
        });
    });
};

onMounted(() => {
    startTypewriter();
});

onUnmounted(() => {
    if (typingInterval) clearInterval(typingInterval);
});
</script>

<style scoped lang="scss">
.hero-section {
    display: flex;
    justify-content: space-between;
    align-items: start;
    flex-direction: row;
    position: relative;

    @media (max-width: 1400px) {
        align-items: center;
        flex-direction: column;
    }

    .hero-explain-section-content-img {
        max-width: 100%;
    }
}



.button-container {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 1400px) {
        justify-content: center;
    }

    >button {
        min-width: 200px;
    }
}

.cycling-word {
    display: inline-block;
    min-width: 240px;
    text-align: start;
    position: relative;
}

.typing-text {
    display: inline-block;
    font-family: inherit;
}

.typing-cursor {
    display: inline-block;
    color: var(--bs-primary);
    animation: blink 1s steps(1) infinite;
    margin-left: 2px;
    font-size: 1.1em;
}

@keyframes blink {

    0%,
    50% {
        opacity: 1;
    }

    51%,
    100% {
        opacity: 0;
    }
}


.header-description {
    color: var(--bs-text-color);
    max-width: 600px;
    margin-block: 38px;

    @media (max-width: 1400px) {
        margin-inline: auto;
    }
}
</style>